import axios from "axios";

export class RGWithdrawals {
    get(filters) {
        return axios.post(`/api/financials/withdrawals/rg`, { filters: filters })
    }
}